<template functional>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :width="props.size"
        :height="props.size"
        :viewBox="`0 0 19 19`"
    >
        <defs>
            <clipPath id="clip-path">
                <rect
                    id="Rectangle_19101"
                    data-name="Rectangle 19101"
                    :width="props.size"
                    :height="props.size"
                    transform="translate(-21113 15345)"
                    fill="#5b73e8"
                />
            </clipPath>
        </defs>
        <g
            id="ico_-_transfer_-_default"
            data-name="ico - transfer - default"
            transform="translate(21113 -15345)"
            clip-path="url(#clip-path)"
        >
            <g
                id="transfer-svgrepo-com_1_"
                data-name="transfer-svgrepo-com (1)"
                transform="translate(-21112.98 15345.5)"
            >
                <g
                    id="Group_13328"
                    data-name="Group 13328"
                    transform="translate(0.5 0)"
                >
                    <path
                        id="Path_28019"
                        data-name="Path 28019"
                        d="M.5,4.893V6.5a.45.45,0,1,0,.9,0V4.893A2.631,2.631,0,0,1,4.027,2.267H6.3l-.6.6a.451.451,0,0,0,.639.636L7.707,2.134a.45.45,0,0,0,.132-.32.457.457,0,0,0-.132-.32L6.344.132a.449.449,0,0,0-.636.636l.6.6H4.03A3.538,3.538,0,0,0,.5,4.893Z"
                        transform="translate(-0.5 0)"
                        fill="#5b73e8"
                    />
                    <path
                        id="Path_28020"
                        data-name="Path 28020"
                        d="M9.724,251.1H1.852a.452.452,0,0,0-.452.452v7.872a.452.452,0,0,0,.452.452H9.724a.452.452,0,0,0,.452-.452v-7.876A.456.456,0,0,0,9.724,251.1Zm-.452,7.872H2.3V252H9.276v6.972Z"
                        transform="translate(-1.367 -241.876)"
                        fill="#5b73e8"
                    />
                    <path
                        id="Path_28021"
                        data-name="Path 28021"
                        d="M296.588,300.7a.452.452,0,0,0-.452.452v1.609a2.631,2.631,0,0,1-2.627,2.627h-2.274l.6-.6a.449.449,0,0,0-.635-.635l-1.363,1.363a.452.452,0,0,0,0,.639l1.363,1.363a.451.451,0,0,0,.639-.636l-.6-.6h2.274a3.532,3.532,0,0,0,3.527-3.527v-1.613A.452.452,0,0,0,296.588,300.7Z"
                        transform="translate(-279.076 -289.654)"
                        fill="#5b73e8"
                    />
                    <path
                        id="Path_28022"
                        data-name="Path 28022"
                        d="M258.024.1h-7.872a.452.452,0,0,0-.452.452V8.424a.452.452,0,0,0,.452.452h7.872a.451.451,0,0,0,.452-.452V.552A.454.454,0,0,0,258.024.1Zm-.452,7.872H250.6V1h6.969Z"
                        transform="translate(-240.546 -0.096)"
                        fill="#5b73e8"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconTransfer",

    props: {
        size: { type: [String, Number], default: "19px" },
    },
};
</script>
